import React, { type FunctionComponent } from 'react'
import styled from '@emotion/styled'
import { spacing } from '@retailer-platform/shared-components'
import { DefaultEmptyState } from '@retailer-platform/shared-components/src/common/grid/components/DefaultEmptyState'
import { useAttributeOverridesColumns } from 'domains/products/components/view/utils/useAttributeOverridesColumns.hooks'
import { PaginatedGrid } from '@retailer-platform/shared-components'
import { useGetValueBasedOverrides } from 'domains/products/api/getValueBasedOverrides.hooks'
import { useDomainMessages } from 'domains/products/utils/domain/intl'
import { ErrorPage } from 'gin-and-tonic/containers/error-page/ErrorPage'

interface ProductsViewAttributeOverridesProps {
  productId: string
  retailerId: string
}

const TableContainer = styled.div({
  flex: 1,
  display: 'flex',
  flexDirection: 'column',
  overflow: 'hidden',
  paddingButtom: spacing.X20,
  width: '100%',
  marginLeft: spacing.X20,
  marginRight: spacing.X20,
})

export const ProductsViewAttributeOverrides: FunctionComponent<
  ProductsViewAttributeOverridesProps
> = ({ productId, retailerId }) => {
  const { valueBasedOverrides, apiError, apiLoading, apiRefetch } = useGetValueBasedOverrides(
    retailerId,
    productId
  )

  const columns = useAttributeOverridesColumns()

  const messages = useDomainMessages({
    noOverrides: 'productsDomain.view.tabs.attributeOverrides.noOverrides',
    error: 'productsDomain.view.tabs.attributeOverrides.loadingError.message',
  })

  if (apiError) {
    return <ErrorPage action={() => apiRefetch}>{messages.error}</ErrorPage>
  }

  if (!apiLoading && (!valueBasedOverrides || valueBasedOverrides.length === 0)) {
    return <DefaultEmptyState emptyStateMessage={messages.noOverrides} />
  }

  return (
    <TableContainer>
      <PaginatedGrid
        columns={columns}
        data={valueBasedOverrides || []}
        page={1}
        totalPages={1}
        disablePagination={true}
        hidePagination={true}
        isLoading={apiLoading}
        onPageChange={() => {
          /* noop */
        }}
      />
    </TableContainer>
  )
}
